import styled from 'styled-components'
import React from 'react'

const Icon = styled.div`
    margin: 0 30px;
    flex-shrink: 0;
    height: 59px;
`

const IconGIF = styled(Icon)`
    width: 54px;
    background: url('/static/img/svg/uploadGifs.svg') no-repeat center;
`

const IconSticker = styled(Icon)`
    width: 48px;
    background: url('/static/img/svg/uploadStickers.svg') no-repeat center;
`

const IconVideo = styled(Icon)`
    width: 44px;
    background: url('/static/img/svg/uploadVideos.svg') no-repeat center;
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 25px 0;
    width: 100%;
`

const CopyContainer = styled.div`
    align-self: center;
    margin: 15px 30px 0px;
`

const Subtitle = styled.div`
    font-weight: 700;
    font-size: 16px;
    padding-bottom: 4px;
`

const Description = styled.div`
    font-size: 15px;
    text-align: center;
    margin-top: 4px;
`

const BetaPill = styled.img`
    position: absolute;
    right: 12px;
    top: 12px;
    height: 21px;
`

const getIcon = type => {
    switch (type) {
        case 'gif':
            return <IconGIF />
        case 'sticker':
            return <IconSticker />
        case 'video':
            return <IconVideo />
        default:
            return <IconGIF />
    }
}

const FilePortalInputButton = ({ label, description, icon, betaPill = false }: FilePortalInputButtonProps) => {
    return (
        <Container>
            {getIcon(icon)}
            <CopyContainer>
                <Subtitle>{label}</Subtitle>
                <Description>{description}</Description>
            </CopyContainer>
            {betaPill && <BetaPill src="/static/img/svg/pill-new.svg" />}
        </Container>
    )
}

type FilePortalInputButtonProps = {
    label: string
    description: string
    icon: string
    betaPill?: boolean
}

export default FilePortalInputButton
